import { urlImages } from 'config'

function StatusRepairDetails ({ order }) {

  const getClassStatus = () => {
    switch(order.status) {
      case 'Zakończone':
        return 'zakonczona';
      break;
      default:
        return 'realizacja';
      break;
    }
  }

  const renderWorkflow = () => {
    return (
      <div className="activity-container">
        <h3>Aktywność</h3>
        <ul className="activity">
          { order.history.map((item, key) => {
              return (
                <li key={key}>
                  <span>{ item.eventName }</span>
                  <span className="activity-date">
                    { item.eventDate }&nbsp;
                    <span dangerouslySetInnerHTML={{ __html: item.additionalInfo}} />
                  </span>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
  
  const renderAdditionalInfo = () => {
    return (
      <>
        <h3>Opis wykonywanych czynności</h3>
        <p>{ order.repairDescription }</p>
      </>
    )
  }

  return (
    <div className="row status-container">
      <div className="col-md-1"></div>
      <div className="col-md-10">
        <h2 className="status-title">Status naprawy</h2>
        <p className="nr-zlecenia">Numer zlecenia (RMA): { order.orderId }</p>

        <div className="row">
          <div className="col-md-6">
            <div className="status-tile">
              <div className="status-tile-title">Marka produktu</div>
              <div className="status-tile-content">{ order.brand }</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="status-tile">
              <div className="status-tile-title">Model produktu</div>
              <div className="status-tile-content">{ order.modelName }</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="status-tile">
              <div className="status-tile-title">Status zlecenia</div>
              <div className="status-tile-content">
                <span className={"status-icon "+getClassStatus()}></span>
                { order.status }
              </div>
              <button type="button" className="btn-help" 
                    data-toggle="tooltip" 
                    data-html="true" 
                    title="">
                    <img src={urlImages + "images/icons/help-icon.svg"} alt="" />
                  </button>
            </div>
          </div>
          
        </div>
        {order.history && renderWorkflow()}
        <div className="status-desc">
          {order.repairDescription && renderAdditionalInfo()}
          <a href="/status-naprawy/" className="secondary-button">Sprawdź kolejny status</a>
        </div>
      </div>
      <div className="col-md-1"></div>
    </div>
  )
}

export default StatusRepairDetails